export class NativeStandardConfig {
    'vaultProtectionMode';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "vaultProtectionMode",
            "baseName": "vaultProtectionMode",
            "type": "NativeStandardConfigVaultProtectionModeEnum",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return NativeStandardConfig.attributeTypeMap;
    }
    constructor() {
    }
}
export var NativeStandardConfigVaultProtectionModeEnum;
(function (NativeStandardConfigVaultProtectionModeEnum) {
    NativeStandardConfigVaultProtectionModeEnum["None"] = "none";
    NativeStandardConfigVaultProtectionModeEnum["VaultLockGovernance"] = "vault-lock-governance";
    NativeStandardConfigVaultProtectionModeEnum["VaultLockCompliance"] = "vault-lock-compliance";
    NativeStandardConfigVaultProtectionModeEnum["AirGapped"] = "air-gapped";
})(NativeStandardConfigVaultProtectionModeEnum || (NativeStandardConfigVaultProtectionModeEnum = {}));
